import { render, staticRenderFns } from "./chart.vue?vue&type=template&id=c8ccc446&scoped=true&"
import script from "./chart.vue?vue&type=script&lang=js&"
export * from "./chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ccc446",
  null
  
)

export default component.exports